import { useState } from "react";

/**
 * Round 50 item 3 — one place for user DPs in the admin panel: a missing,
 * blank or broken image URL shows a neutral default silhouette instead of an
 * empty circle (the Android app uses its bundled ic_user_avatar_default for
 * the same cases).
 */
const DEFAULT_AVATAR =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" fill="#E5E7EB"/><circle cx="32" cy="24" r="11" fill="#9CA3AF"/><path d="M10 58c2-13 11-20 22-20s20 7 22 20z" fill="#9CA3AF"/></svg>'
  );

export function Avatar({ src, className = "h-8 w-8 rounded-full object-cover" }: { src?: string | null; className?: string }) {
  const valid = typeof src === "string" && /^https?:\/\//i.test(src.trim());
  const [failed, setFailed] = useState(false);
  return <img src={valid && !failed ? src!.trim() : DEFAULT_AVATAR} alt="" className={className} onError={() => setFailed(true)} />;
}
